import { doc, getDoc } from 'firebase/firestore'
import db from '../firebase-config'
import useSWR from 'swr'
import { BlogPost } from '@/components/Blogs/Blogs'

export function useBlogPost(blogId?: string) {
  const isDev = false

  const fetchBlogPost = async (): Promise<BlogPost | null> => {
    console.log('Blog Docs: ')
    const querySnapshot = await getDoc(doc(db, 'Blogs', blogId || ''))

    // (doc: QueryDocumentSnapshot<DocumentData, DocumentData>) => {
    if (querySnapshot.exists()) {
      const docData = querySnapshot.data()

      const post: BlogPost = {
        uuid: querySnapshot.id,
        id: docData.id,
        title: docData.title,
        author: docData.author,
        authorImg: docData.author_img,
        body: docData.body,
        category: docData.category,
        created: docData.created,
        position: docData.position,
        headerImg: docData.header_img,
      }
      console.log('B Docs: ', JSON.stringify(post))
      return post
    }

    return null
  }

  if (isDev) {
    return {
      blogs: [] as BlogPost[],
      isLoading: false,
      isError: false,
    }
  }

  const { data, error, isLoading } = useSWR(
    `/api/blogs/${blogId}`,
    fetchBlogPost,
  )

  return {
    post: data,
    isLoading,
    isError: error,
  }
}
